<template>
  <div>
    <div class="section-header standalone">
      <h2 class="section-title">{{ title }}</h2>
      <router-link v-if="viewAllLink" :to="viewAllLink" class="btn-flat blue-text view-all-btn">
        {{ viewAllText }} <i class="material-icons" style="font-size: 1rem; margin-left: 4px;">arrow_forward</i>
      </router-link>
    </div>
    <hr class="section-divider" />
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    viewAllLink: {
      type: String,
      default: null
    },
    viewAllText: {
      type: String,
      default: 'View All'
    }
  }
};
</script>

<style scoped>
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: none;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 10px;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #00205b;
  margin: 0;
  font-family: 'Zen Kaku Gothic New', sans-serif;
}

.section-divider {
  border: 0;
  height: 1px;
  background-color: #eaeaea;
  margin: 0 0 20px 0;
}

.view-all-btn {
  font-weight: 500;
  padding: 6px 14px;
  border-radius: 4px;
  transition: all 0.3s ease;
  background-color: rgba(33, 150, 243, 0.05);
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.view-all-btn:hover {
  background-color: rgba(33, 150, 243, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .view-all-btn {
    align-self: flex-end;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionHeader.vue